import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

export function ReassignAttendanceDialog({ open, onClose, token, month, fromName, candidates, onDone }) {
  const [to, setTo] = useState("");
  const [allMonths, setAllMonths] = useState(false);
  const [preview, setPreview] = useState(null);
  const [reason, setReason] = useState("");
  const close = () => { setTo(""); setPreview(null); setReason(""); onClose(); };
  const call = async (dry) => {
    try {
      const r = await api.post("/payroll-corrections/reassign-attendance", { token, from_name: fromName,
        to_employee_id: to, month: allMonths ? null : month, reason, dry_run: dry });
      if (dry) setPreview(r.data);
      else { toast.success(`Moved ${r.data.moved} attendance day(s) to ${r.data.to.name}`); onDone?.(); close(); }
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-lg" data-testid="reassign-dialog">
        <DialogHeader>
          <DialogTitle>Reassign attendance of “{fromName}”</DialogTitle>
          <DialogDescription>Moves attendance recorded under this name to one Employee ID. Originals are archived and the change is audited. Nothing is merged automatically.</DialogDescription>
        </DialogHeader>
        <div className="flex flex-wrap gap-1">
          {(candidates || []).filter((c) => c.employeeId).map((c) => (
            <Button key={c.employeeId} size="sm" variant={to === c.employeeId ? "default" : "outline"}
              onClick={() => { setTo(c.employeeId); setPreview(null); }} data-testid={`reassign-pick-${c.employeeId}`}>
              {c.name} · {c.employeeId}</Button>))}
        </div>
        <Input placeholder="…or type target Employee ID" value={to} onChange={(e) => { setTo(e.target.value); setPreview(null); }}
          data-testid="reassign-target-id" />
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={allMonths}
          onChange={(e) => { setAllMonths(e.target.checked); setPreview(null); }} data-testid="reassign-all-months" />
          All months (not only {month})</label>
        {preview && (
          <div className="text-xs border rounded p-2" data-testid="reassign-preview">
            Will move <b>{preview.will_move}</b> day(s) to <b>{preview.to.name}</b> ({preview.months.join(", ") || "—"}).
            {preview.conflicts.length > 0 && <div className="text-amber-700">{preview.conflicts.length} date(s) already recorded for the target — those are kept and not moved.</div>}
          </div>)}
        {preview && <Textarea rows={2} placeholder="Reason" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="reassign-reason" />}
        <DialogFooter>
          <Button variant="outline" onClick={() => call(true)} disabled={!to} data-testid="reassign-preview-btn">Preview</Button>
          <Button onClick={() => call(false)} disabled={!preview || reason.trim().length < 5} data-testid="reassign-apply-btn">Apply</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
